module.exports = __webpack_public_path__ + "static/en-section-5@2x-32d0f07962d6b90f626b9a3f018c5178.png";